import React from 'react';
import Icon from '../../../components/AppIcon';

const RouteCard = ({ route, onClick }) => {
  const getStatusColor = () => {
    if (route?.status === 'passed') return 'text-muted-foreground';
    if (route?.estimatedMinutes <= 5) return 'text-success';
    if (route?.estimatedMinutes <= 10) return 'text-warning';
    return 'text-primary';
  };

  const getStatusBadge = () => {
    if (route?.status === 'passed') return { text: 'Geçti', color: 'bg-muted' };
    if (route?.estimatedMinutes <= 5) return { text: 'Yaklaşıyor', color: 'bg-success/10 text-success' };
    return { text: 'Aktif', color: 'bg-primary/10 text-primary' };
  };

  const statusBadge = getStatusBadge();

  return (
    <div
      onClick={onClick}
      className="bg-card border border-border rounded-xl p-4 md:p-6 hover:shadow-lg transition-all cursor-pointer group"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg md:text-xl font-bold text-foreground group-hover:text-primary transition-colors">
              {route?.name}
            </h3>
            {route?.aiEnhanced && (
              <div className="flex items-center gap-1 px-2 py-0.5 bg-primary/10 rounded-full">
                <Icon name="Sparkles" size={12} color="var(--color-primary)" />
                <span className="text-xs font-medium text-primary">AI</span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} />
            <span>{route?.startPoint}</span>
            <Icon name="ArrowRight" size={14} />
            <span>{route?.endPoint}</span>
          </div>
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-medium ${statusBadge?.color}`}>
          {statusBadge?.text}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Route" size={16} color="var(--color-muted-foreground)" />
          <div>
            <p className="text-xs text-muted-foreground">Mesafe</p>
            <p className="text-sm font-semibold text-foreground">{route?.distance}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
          <div>
            <p className="text-xs text-muted-foreground">Kalkış Saati</p>
            <p className="text-sm font-semibold text-foreground">{route?.nextDeparture}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Icon name="Timer" size={16} color={getStatusColor()} />
          <div>
            <p className="text-xs text-muted-foreground">Tahmini</p>
            <p className={`text-sm font-semibold ${getStatusColor()}`}>
              {route?.status === 'passed' ? 'Geçti' : `${route?.estimatedMinutes} dk`}
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={14} />
          <span>{route?.aiEnhanced ? 'AI destekli tahmin' : 'Kalkış Saatleri'}</span>
        </div>
        <div className="flex items-center gap-1 text-primary group-hover:gap-2 transition-all">
          <span className="text-sm font-medium">Detaylar</span>
          <Icon name="ChevronRight" size={16} />
        </div>
      </div>
    </div>
  );
};

export default RouteCard;